import axios from 'axios'
import Store from '../../store'
import { errorHandler, successHandler } from '../helpers/handler'
import { BASEURL } from '../const'

const URL = `${BASEURL}/ranks`

export default {
  rankApi() {
    return {
      getAllRanks: async (params) => {
        try {
          const res = await axios.get(URL, {
            params,
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      getUserCurrentRank: async () => {
        const endpoint = `${URL}/current-user`
        try {
          const res = await axios.get(endpoint, {
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      }
    }
  }
}
